import type { ReactNode } from 'react';
import { AuthBrandPanel } from '../BrandPanel';

/**
 * The shell every auth screen sits in.
 *   Mobile  — a single light "paper" surface that owns its own native-momentum scroll;
 *             the phone-width column fills the device.
 *   Desktop — a real two-pane app: a persistent dark brand rail on the left and the
 *             screen's content as a centred card on the right, on the canvas backdrop.
 * The children are identical across breakpoints; only the frame around them changes,
 * so each screen stays a single source of truth.
 */
export function AuthPage({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-full flex-col bg-surface-top md:flex-row md:bg-canvas">
      <AuthBrandPanel />
      {/* Internal scroller so tall content (or an open keyboard) scrolls with native
          momentum, while the document stays locked. min-h-full keeps the column at
          least a screen tall so flex-1 spacers still centre short content. On desktop
          the column becomes an auto-height card vertically centred via my-auto (which
          collapses to 0 when content is taller than the pane, so it still scrolls). */}
      <div className="native-scroll no-scrollbar flex-1 overflow-y-auto px-safe pt-safe pb-safe md:flex md:flex-col md:px-10 md:py-10">
        <div className="mx-auto flex min-h-full w-full max-w-app flex-col md:my-auto md:min-h-0 md:max-w-[424px] md:rounded-[28px] md:border md:border-black/5 md:bg-white md:px-9 md:py-8 md:shadow-card">
          {children}
        </div>
      </div>
    </div>
  );
}
